import { render, staticRenderFns } from "./InstitutionAndDepartment.vue?vue&type=template&id=77e22ec4&"
import script from "./InstitutionAndDepartment.vue?vue&type=script&lang=js&"
export * from "./InstitutionAndDepartment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports